<ng-container [ngSwitch]="status" xmlns="http://www.w3.org/1999/html">
    <div *ngSwitchCase="'Not Started'">
        <span class="ag-cell-value">{{ 'longRequestCenter.notStarted' | translate }}</span>
    </div>
    <div *ngSwitchCase="'Completed'" [ngSwitch]="resultType">
        <span *ngSwitchCase="'download'" class="icon-container download">
            <p-icon name="download"></p-icon>
            <p-link (onClick)="downloadFile()" [attr.automation-id]="resultLink">{{ 'longRequestCenter.downloadLink' | translate }}</p-link>
        </span>
        <span *ngSwitchCase="'test'">
            <p-link [url]="resultLink" [attr.automation-id]="'resultLinkTest'">{{ 'longRequestCenter.openTest' | translate }}</p-link>
        </span>
        <span *ngSwitchCase="'link'" class="icon-container download">
            <p-icon name="Link"></p-icon>
            <p-link [url]="resultLink" [attr.automation-id]="'resultLinkUrl'">{{ 'longRequestCenter.gotoLink' | translate }}</p-link>
        </span>
        <span *ngSwitchDefault class="ag-cell-value icon-container completed">
            <p-icon name="check-circle"></p-icon>
            {{ 'longRequestCenter.completed' | translate }}
        </span>
    </div>
    <div *ngSwitchCase="'Failed'" class="icon-container failed">
        <p-icon name="x-circle"></p-icon>
        <span class="failed">{{ 'longRequestCenter.failed' | translate }}</span>
    </div>
    <div *ngSwitchCase="'In Progress'" class="in-progress">
        <ng-container *ngIf="progressPercentage > 0 && progressPercentage < 100; else noProgressBar">
            <p-field-static-progress-bar [isLink]="false" [value]="progressPercentage"></p-field-static-progress-bar>
        </ng-container>
        <ng-template #noProgressBar class="ag-cell-value">
            {{ 'longRequestCenter.inProgress' | translate }}
        </ng-template>
    </div>
</ng-container>
